import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SetMeta from '../components/SetMeta';
import TrackList from '../components/TrackList';
import LoadingScreen from '../components/LoadingScreen';
import { on, off } from '../utils/events';
import { useApi } from '../context/ApiProvider';
import { usePlay } from '../context/Play';
import CommentsSection from '../components/sections/CommentsSection';
import TabsContainer from '../components/TabsContainer';
import { getShareToken, getShareContent } from '../utils/shareToken';

const Set = () => {
  const api = useApi();
  const { showShareModal } = usePlay();
  const [loading, setLoading] = useState(false);
  const [set, setSet] = useState({});
  const { id } = useParams();
  const updateMetaLikes = React.useCallback(() => {
    loadSet();
  }, []);

  useEffect(() => {
    on('updateMetaLikes', updateMetaLikes);
    return () => {
      off('updateMetaLikes', updateMetaLikes);
    };
  }, [updateMetaLikes]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await loadSet();
      setLoading(false);
    })();
  }, [id]);

  // Check for share link after set data is loaded
  useEffect(() => {
    if (set.id && set.set_name) {
      const shareToken = getShareToken();
      const shareContent = getShareContent();

      if (shareToken && shareContent) {
        // Check if content ID matches and modal hasn't been shown
        const token = shareToken;
        const modalShownKey = `kip_share_modal_shown_${token}`;
        const modalAlreadyShown = sessionStorage.getItem(modalShownKey);

        if (
          shareContent.contentType === 'set' &&
          shareContent.contentId === set.id &&
          !modalAlreadyShown
        ) {
          // Build content name: "set_name - artist_name" or just "set_name"
          const contentName = set.artist_meta?.name
            ? `${set.set_name} - ${set.artist_meta.name}`
            : set.set_name;
          showShareModal('set', contentName, set.id);
        }
      }
    }
  }, [set.id, set.set_name, set.artist_meta, showShareModal]);

  async function loadSet() {
    const response = await api.get(`/sets/${id}`);
    if (response.ok) {
      setSet(response.body);
    } else {
      console.log(response);
    }
  }

  return (
    <>
      {loading && <LoadingScreen />}
      <SetMeta meta={set} />

      <TabsContainer
        tabTitles={[{ title: 'Track List' }, { title: 'Comments' }]}
        tabContent={[
          <TrackList
            tracks={set.set_tracks}
            setReleaseDate={set.release_date}
            key={'tracklist'}
          />,
          <CommentsSection
            commentsFrom={`/sets/${id}/posts`}
            setId={parseInt(id)}
            key="Comments"
          />,
        ]}
      />
    </>
  );
};

export default Set;
